<template>
  <!-- 加关注弹窗 -->
  <van-popup
    v-model="localVisible"
    :position="position"
    get-container="body"
    :close-on-click-overlay="false"
    class="jbs-subscribe-popup"
    :style="{ background: 'transparent' }"
    :transition="transition"
  >
    <div :class="['content-container', variant]">
      <img
        class="close-icon"
        src="./images/icon-close.png"
        @click="cancel"
      />
      <template v-if="variant === 'daily'">
        <div class="title">每天上午10点<br />给你最新职位提醒</div>
        <div class="action-button mt24" @click="subscribe">加个关注</div>
      </template>
      <template v-if="variant === 'retention'">
        <div class="title">要走了吗？加个关注吧～</div>
        <div class="sub-title">每天上午10点给你最新职位提醒</div>
        <div class="action-button mt24" @click="subscribe">立即关注</div>
      </template>
      <template v-if="variant === 'focusMore'">
        <div class="title">要走了吗？加个关注吧～</div>
        <div class="sub-title">每天上午10点给你最新职位提醒</div>
        <div class="goodList">
          <span v-for="(item,index) in goodList" :class="{active:!item.unchecked}" :key="item.id" @click="checkGood(index)">{{item.name}}</span>
        </div>
        <div class="action-button" :class="{disabled:(subjectIds.length <= 0)}" @click="subscribe">一键关注</div>
        <div class="leave" @click="leave">残忍离开</div>
      </template>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SubscribePopup",
  emits: ["update:subscriptionId", "cancel"],
  props: {
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      variant: "daily",
      goodList:[],
      localVisible:false
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    position() {
      return {
        daily: "center",
        retention: "center",
      }[this.variant];
    },
    transition() {
      return {
        daily: "daily",
      }[this.variant];
    },
    subjectIds(){
      let idLists = this.goodList.filter((item)=>!item.unchecked);
      let ids = idLists.map(item=>item.id);
      return ids;
    }
  },
  watch:{
    //v0402： 如果页面已经存在弹窗,不再弹出引导弹窗,防止同一时间弹出多个弹窗
    show(newValue){
      if(newValue){
        if (this.commonStore.hasPopupVisible) {
          // 如果已经有弹窗显示，则关闭当前弹窗
          this.localVisible = false;
          return;
        }
        this.localVisible = true;
      }else{
        this.localVisible = false;
      }
    },
    //v0402： 如果页面已经存在弹窗,不再弹出引导弹窗,防止同一时间弹出多个弹窗
    localVisible(newValue){
      if(newValue){
        this.$store.commit("setPopupVisible", true);// 标记弹窗已显示
      }else{
        this.$store.commit("setPopupVisible", false);// 标记弹窗已关闭
      }
    }
  },
  mounted() {
  },

  methods: {
    // variant: daily | retention | focusMore
    // 对应 弹窗展示场景区分：曝光达标场景、返回挽留场景 、关注更多专区弹窗
    open({ variant = "daily" } = {}) {
      this.show = true;
      this.variant = variant;
      if(variant == 'focusMore'){
        this.goodList = JSON.parse(this.commonStore.unSubscribeGoodIds);
        console.log("未关注的专区列表",this.goodList);
      }
    },
    cancel() {
      this.close();
      this.$emit("cancel");
    },
    close() {
      this.show = false;
    },
    async subscribe() {//点击关注
      if(this.variant === 'focusMore' && this.subjectIds && this.subjectIds.length <= 0){
        return false;
      }else if(this.variant === 'focusMore'){
        console.log("subjectIds",this.subjectIds);
        sessionStorage.setItem("subjectIds",JSON.stringify(this.subjectIds));
      }
      this.cancel();
      this.$EventBus.$emit('subscribeEvent',this.variant);
    },
    leave(){
      this.cancel();
      this.$base.goBack(this.pageConfig?.prevLink);
    },
    checkGood(index){
      this.$set(this.goodList[index],"unchecked",!this.goodList[index].unchecked);
    }
  },
};
</script>

<style lang="less" scoped>
.jbs-subscribe-popup {
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 316px;
    border-radius: 16px;
    position: relative;

    background-image: url("./images/subscribePopupBg.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-color: white;

    .bell {
      margin-top: 16px;
      width: 100px;
      height: 100px;
    }

    .title {
      margin-top: 129px;

      font-weight: 500;
      font-size: 20px;
      color: #222222;
      line-height: 28px;
      text-align: center;
      font-style: normal;
    }
    .action-button {
      width: 200px;
      height: 44px;
      background: linear-gradient(180deg, #ffb240 0%, #ff6300 100%);
      box-shadow: inset 0px 3px 9px 0px #ff6906;
      border-radius: 22px;
      border: 1px solid #ffe7ce;

      display: flex;
      justify-content: space-around;
      align-items: center;

      line-height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      &.mt24{
        margin-top: 24px;
      }
      &.disabled{
        opacity: 0.6;
      }
    }

    .sub-title {
      margin-top: 6px;
      font-weight: 400;
      font-size: 16px;
      color: #4C4F54;
      line-height: 22px;
      text-align: center;
      font-style: normal;
    }
    .goodList{
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 8px 15.5px 14px;
      span{
        width: 88px;
        text-align: center;
        font-family: PingFang SC;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        color: #222222;
        border-radius: 16px;
        padding: 8px 0;
        background: #F2F4F7;
        margin-right: 8px;
        margin-top: 10px;
        &:nth-child(3n){
          margin-right: 0;
        }
        &.active{//checkedIcon
          background: #FFF1EB;
          color: #FF5500;
          position: relative;
          &::before{
            content: '';
            display: block;
            width: 10px;
            height: 10px;
            position: absolute;
            top: 0;
            right: 0;
            background: url("./images/checkedIcon.png") no-repeat center center;
            background-size: contain;
          }
        }
      }
    }
    .leave{
      padding: 8px 0 12px 0;
      font-size: 14px;
      text-align: center;
      color: #8C8F8D;
    }
    .close-icon {
      position: absolute;
      top: 9px;
      left: 9px;
      width: 20px;
      height: 20px;
    }
    &.daily{
      padding-bottom: 32px;
    }
    &.retention {
      padding-bottom: 32px;
      .action-button {
        margin-bottom: 0;
      }

      .zone-button {
        margin-top: 12px;

        width: 200px;
        height: 44px;
        border-radius: 22px;
        border: 1px solid #ff6e08;

        display: flex;
        justify-content: space-around;
        align-items: center;

        font-weight: 400;
        font-size: 16px;
        color: #ff6e08;
        line-height: 22px;
        text-align: center;
        font-style: normal;
      }
    }

    &.feedback {
      width: 100%;
      border-radius: 16px 16px 0 0;
      padding-bottom: 30px;

      background-image: linear-gradient(180deg, #fffce1 0%, #ffffff 100%);

      .title {
        margin-top: 44px;

        font-size: 18px;
        line-height: 25px;
      }

      .action-button {
        margin-top: 30px;
      }
    }
  }
}
</style>
